import { Skeleton } from '@/components/ui/skeleton';
import { Box, Flex, HStack, VStack } from '@chakra-ui/react';
import React from 'react';

interface ConversationItemSkeletonProps {
  count?: number;
}

const ConversationItemSkeleton: React.FC<ConversationItemSkeletonProps> = ({ count = 5 }) => {
  return (
    <VStack gap="1px" align="stretch" w="full">
      {Array.from({ length: count }).map((_, i) => (
        <Box key={i} py={2.5} px={2.5}>
          <Flex gap={2} align="start">
            <Skeleton height="24px" width="24px" rounded="full" mt="2px" />
            <Box flex="1" minW={0}>
              <HStack justify="space-between" mb={1}>
                <Skeleton height="14px" width={`${60 + (i % 3) * 20}px`} />
                <Skeleton height="12px" width="36px" />
              </HStack>
              <Skeleton height="12px" width="80%" />
            </Box>
          </Flex>
        </Box>
      ))}
    </VStack>
  );
};

export default ConversationItemSkeleton;
